import React from "react";
import { useSelector } from "react-redux";
import { PresentationType } from "../../redux/alerts";
import { residentsStatusItemsToDisplay } from "../../redux/alerts/selectors";
import { IAppState } from "../../redux/types";
import OneStatusView from "./OneStatusView";
import "./styles.scss";
const StatusContent = ({
  callback,
}: {
  callback: (...args: any) => void;
}): JSX.Element => {
  const displayedResidents = useSelector(residentsStatusItemsToDisplay);

  const { presentation } = useSelector(
    (state: IAppState) => state.alerts.settings
  );
  const children = displayedResidents.map((resident, index) => {
    return (
      <OneStatusView
        residentId={resident?.id}
        key={(resident?.id ? resident?.id : "") + index}
        callback={callback}
        index={index}
      />
    );
  });
  return presentation === PresentationType.Cards ||
    presentation === PresentationType.List ? (
    <div
      className={`status-list flex-column flex-column-${
        presentation === PresentationType.Cards ? "24" : "8"
      }`}
    >
      {children}
    </div>
  ) : (
    <div className="status-list flex-tile-status">{children}</div>
  );
};
export default React.memo(StatusContent);
